<div class="Loading" *ngIf="isShowLoading==true">
        <div class="loader"></div>
        <label class="loaderlabel">Please wait while Processing Image....</label>
      </div>
      <div class="DriverForm">
        <div class="Field">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="card" style="width:100%;" id="InsuredInfo">
              <ul class="nav nav-tabs listdata" role="tablist">
                <li role="presentation" class="active">
                  <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Uploads Information' | translate }}</a>
                </li>
              </ul>
      
              <div class="tab-content detailsTab">
      
                <div role="tabpanel" class="tab-pane active" id="home">
                  <div class="InsuredForm">
                    <div class="row">
      
                      <!-- Front Image -->
                      <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" *ngIf="prObj.SelectedProductCode=='5520'">
                        <div class="panel panel-default">
      
                          <div class="panel-body">
                            <p class="text-center text-muted">
                              <i class="fa fa-camera fa-4x"></i>
                            </p>
                            <h4 class="text-center text-muted"> {{ 'Front side' | translate }}
                              <small uib-tooltip="For New Arrivals">
                                <i class="fa fa-info-circle"></i>
                              </small>
                              <br>
                              <small>({{ 'Scan Copy' | translate}} )</small>
      
                            </h4>
      
                            <div style="position:relative;">
                              <a class="btn btn-block" href='javascript:;'>
                                <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
                                <input type="file" (change)="processImage($event,'front',true)" style='width: 100%; position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" capture="environment" />
      
                                <i class="fa fa-upload"></i>
                              </a>
      
                              <!-- <img *ngIf="attachments.frontImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.frontImage}}" height="75px"> -->
                              <img *ngIf="prObj.frontImage!=null" class="img-thumbnail imgdisplay" src="{{ attachments.frontBase64Image!=null ? 'data:image/jpg;base64,' + attachments.frontBase64Image : attachments.frontImage}}" height="75px"  onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
      
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <!-- BackImage -->
                      <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" *ngIf="prObj.SelectedProductCode=='5520'">
                        <div class="panel panel-default">
                          <div class="panel-body">
                            <p class="text-center text-muted">
                              <i class="fa fa-camera fa-4x"></i>
                            </p>
                            <h4 class="text-center text-muted">{{ 'Back side' | translate }}
                              <small uib-tooltip="For New Arrivals">
                                <i class="fa fa-info-circle"></i>
                              </small>
                              <br>
                              <small>({{ 'Scan Copy' | translate}} )</small>
                            </h4>
      
                            <div style="position:relative;">
                              <a class="btn btn-block" href='javascript:;'>
                                <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
                                <input type="file" (change)="processImage($event,'back',true)" style='width: 100%; position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" capture="environment"/>
                                <i class="fa fa-upload"></i>
                              </a>
      
                              <!-- <img *ngIf="attachments.backImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.backImage}}" height="75px"> -->
                              <img *ngIf="prObj.backImage!=null" class="img-thumbnail imgdisplay" src="{{ attachments.backBase64Image!=null ? 'data:image/jpg;base64,' + attachments.backBase64Image : attachments.backImage}}"  height="75px"  onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
                            </div>
                          </div>
                        </div>
                      </div>
      
                    </div>
      
      
                    <div class="row">
                      <!-- Right Image -->
                      <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" *ngIf="prObj.SelectedProductCode=='5520'">
                        <div class="panel panel-default">
      
                          <div class="panel-body">
                            <p class="text-center text-muted">
                              <i class="fa fa-camera fa-4x"></i>
                            </p>
                            <h4 class="text-center text-muted">
                              {{ 'Right Side' | translate }}
                              <small uib-tooltip="For New Arrivals">
                                <i class="fa fa-info-circle"></i>
                              </small>
                              <br>
                              <small>({{ 'Scan Copy' | translate}} )</small>
      
                            </h4>
      
                            <div style="position:relative;">
                              <a class="btn btn-block" href='javascript:;'>
                                <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
      
                                <input type="file" style='width: 100%;  position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" (change)="processImage($event,'right',true)" capture="environment"/>
                                <i class="fa fa-upload"></i>
                              </a>
      
                              <!-- <img *ngIf="attachments.rightImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.rightImage}}" height="75px"> -->
                              <img *ngIf="prObj.rightImage!=null" class="img-thumbnail imgdisplay" src="{{ attachments.rightBase64Image!=null ? 'data:image/jpg;base64,' + attachments.rightBase64Image : attachments.rightImage}}"  height="75px"  onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <!-- Left Image -->
                      <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" *ngIf="prObj.SelectedProductCode=='5520'">
                        <div class="panel panel-default">
      
                          <div class="panel-body">
                            <p class="text-center text-muted">
                              <i class="fa fa-camera fa-4x"></i>
                            </p>
                            <h4 class="text-center text-muted">
                              {{ 'Left side' | translate }}
                              <small uib-tooltip="For New Arrivals">
                                <i class="fa fa-info-circle"></i>
                              </small>
                              <br>
                              <small>({{ 'Scan Copy' | translate}} )</small>
                            </h4>
      
                            <div style="position:relative;">
                              <a class="btn btn-block" href='javascript:;'>
                                <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
      
                                <input type="file" style='width: 100%;  position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" (change)="processImage($event,'left',true)" capture="environment"/>
                                <i class="fa fa-upload"></i>
                              </a>
                              <!-- <img *ngIf="attachments.leftImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.leftImage}}" height="75px"> -->
                              <img *ngIf="prObj.leftImage!=null" class="img-thumbnail imgdisplay" src="{{ attachments.leftBase64Image!=null ? 'data:image/jpg;base64,' + attachments.leftBase64Image : attachments.leftImage}}"  height="75px"   onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
      
      
                    <div class="row">
                      <!-- ChassisNo image -->
                        <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" *ngIf="prObj.SelectedProductCode=='5520'">
                          <div class="panel panel-default">
      
                            <div class="panel-body">
                              <p class="text-center text-muted">
                                <i class="fa fa-camera fa-4x"></i>
                              </p>
                              <h4 class="text-center text-muted"> {{ 'Chassis No' | translate }}
                                <small uib-tooltip="For New Arrivals">
                                  <i class="fa fa-info-circle"></i>
                                </small>
                                <br>
                                <small>({{ 'Scan Copy' | translate}} )</small>
      
                              </h4>
      
                              <div style="position:relative;">
                                <a class="btn btn-block" href='javascript:;'>
                                  <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
      
                                  <input type="file" style='width: 100%; position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" (change)="processImage($event,'chasis',false)" capture="environment"/>
                                  <i class="fa fa-upload"></i>
                                </a>
                                <!-- <img *ngIf="attachments.chasisImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.chasisImage}}" height="75px"> -->
                                <img *ngIf="prObj.chasisImage!=null" class="img-thumbnail imgdisplay" src="{{attachments.chasisBase64Image!=null ? 'data:image/jpg;base64,' + attachments.chasisBase64Image : attachments.chasisImage}}"  height="75px"   onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
                              </div>
                            </div>
                          </div>
                        </div>
      
                        <!-- InsuredId Image -->
                        <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12">
                          <div class="panel panel-default">
      
                            <div class="panel-body">
                              <p class="text-center text-muted">
                                <i class="fa fa-camera fa-4x"></i>
                              </p>
                              <h4 class="text-center text-muted">
                                {{ 'Insured Id' | translate }}
                                <small uib-tooltip="For New Arrivals">
                                  <i class="fa fa-info-circle"></i>
                                </small>
                                <br>
                                <small>({{ 'Scan Copy' | translate}} )</small>
      
                              </h4>
      
                              <div style="position:relative;">
                                <a class="btn btn-block" href='javascript:;'>
                                  <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
                                  <input type="file" (change)="processImage($event,'InsuredId',false)" style='width: 100%; position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;'size="10" accept="image/*" capture="environment" />                            
                                  <i class="fa fa-upload"></i>
                                </a>
                                <!-- <img *ngIf="attachments.InsuredIdImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.InsuredIdImage}}" height="75px"> -->
                                <img *ngIf="prObj.InsuredIdImage!=null" class="img-thumbnail imgdisplay" src="{{attachments.InsuredIdBase64Image!=null ? 'data:image/jpg;base64,' + attachments.InsuredIdBase64Image : attachments.InsuredIdImage}}"  height="75px"   onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
                              </div>
                            </div>
                          </div>
                        </div>
      
                        <!-- Isthimara Image -->
                        <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" *ngIf="prObj.vehcileObj.Vehicle_DefType==2">
                          <div class="panel panel-default">
      
                            <div class="panel-body">
                              <p class="text-center text-muted">
                                <i class="fa fa-camera fa-4x"></i>
                              </p>
                              <h4 class="text-center text-muted">
                                {{ 'Isthimara' | translate }}
                                <small uib-tooltip="For New Arrivals">
                                  <i class="fa fa-info-circle"></i>
                                </small>
                                <br>
                                <small>({{ 'Scan Copy' | translate}})</small>
      
                              </h4>
      
                              <div style="position:relative;">
                                <a class="btn btn-block" href='javascript:;'>
                                  <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
                                  <input type="file" style='width: 100%; position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" (change)="processImage($event,'Isthimara',false)" capture="environment"/>
                                  <i class="fa fa-upload"></i>
                                </a>
                                <!-- <img *ngIf="attachments.IsthimaraImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.IsthimaraImage}}" height="75px"> -->
                                <img *ngIf="prObj.IsthimaraImage!=null" class="img-thumbnail imgdisplay" src="{{attachments.IsthimaraBase64Image!=null ? 'data:image/jpg;base64,' + attachments.IsthimaraBase64Image : attachments.IsthimaraImage}}"  height="75px"   onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
                              </div>
                            </div>
                          </div>
                        </div>
      
                        <!-- CustomId Image -->
                        <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12" *ngIf="prObj.vehcileObj.Vehicle_DefType==3">
                          <div class="panel panel-default">
      
                            <div class="panel-body">
                              <p class="text-center text-muted">
                                <i class="fa fa-camera fa-4x"></i>
                              </p>
                              <h4 class="text-center text-muted">
                                {{ 'Custom Id Copy' | translate }}
                                <small uib-tooltip="For New Arrivals">
                                  <i class="fa fa-info-circle"></i>
                                </small>
                                <br>
                                <small>({{ 'Scan Copy' | translate}})</small>
      
                              </h4>
      
                              <div style="position:relative;">
                                <a class="btn btn-block" href='javascript:;'>
                                  <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
                                  <input type="file" style='width: 100%;  position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" (change)="processImage($event,'CustomId',false)" capture="environment"/>
                                  <i class="fa fa-upload"></i>
                                </a>
                                <!-- <img *ngIf="attachments.CustomIdImage!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + attachments.CustomIdImage}}" height="75px"> -->
                                <img *ngIf="prObj.CustomIdImage!=null" class="img-thumbnail imgdisplay" src="{{attachments.CustomIdBase64Image!=null ? 'data:image/jpg;base64,' + attachments.CustomIdBase64Image : attachments.CustomIdImage}}"  height="75px"   onerror="this.onerror=null; this.src='assets/Images/NoImage.svg'">
                              </div>
                            </div>
                          </div>
                        </div>
      
                    </div>
      
                    <hr class="hr" />
      
      
                  </div>
                  <div class="row" style="margin-right:20px;">
      
                    <label class="declLable">
                      <input type="checkbox" style="zoom:1.5;" id="com" name="comDeclaration" [(ngModel)]="compdeclare" />
                      <a href="{{this.url.DocumentURL}}Downloads/GGCITerms&ConditionsPictures.pdf" class="declaraiontxt" download="declaration" target="_blank"> {{ 'prdec' | translate }}</a>
                    </label>
      
                  </div>
                  <div class="ButtonActions ButtonActionsAr_uploads">
                    <div class="btn-group">
                      <button class="btn btn-primary btnPrev" name="btnPrev" id="btnPrev" (click)="goPrev()">{{'Prev'| translate }}</button>
                      <button class="btn btn-primary btnNext" name="btnNext" id="btnNext" (click)="goNext()">{{'Next'| translate }}</button>
      
                    </div>
                  </div>
      
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/uploadsForm/uploadsForm.html